/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_EstadoError as EstadoError,
  rec_EstructuraPrincipal as EstructuraPrincipal,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_Sn as Sn,
  rec_api as api,
  rec_lt as lt,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function ConectarCalendario() {
  let e = (0, ReactCompiler.c)(12),
    { proveedor: t } = lt(),
    n = (0, React.useRef)(!1),
    [r, i] = (0, React.useState)(``),
    [a, o] = (0, React.useState)(!1),
    s,
    c;
  (e[0] === t
    ? ((s = e[1]), (c = e[2]))
    : ((s = () => {
        if (n.current) return;
        n.current = !0;
        let e = new URLSearchParams(window.location.search);
        if (
          (window.history.replaceState({}, ``, window.location.pathname),
          e.has(`error`) || !e.get(`code`) || !e.get(`state`))
        ) {
          i(
            `No se completó la autorización. Vuelve al calendario para conectar de nuevo.`,
          );
          return;
        }
        api(`/calendario/conexiones/${t.toUpperCase()}/callback`, {
          method: `POST`,
          body: JSON.stringify({
            code: e.get(`code`),
            state: e.get(`state`),
          }),
        })
          .then(() => o(!0))
          .catch((e) => i(e.message));
      }),
      (c = [t]),
      (e[0] = t),
      (e[1] = s),
      (e[2] = c)),
    (0, React.useEffect)(s, c));
  let l;
  e[3] === r
    ? (l = e[4])
    : ((l = <EstadoError mensaje={r} />), (e[3] = r), (e[4] = l));
  let u;
  e[5] !== r || e[6] !== a
    ? ((u = !r && (
        <p
          className={`text-(--text)`}
          children={
            a
              ? `Calendario conectado. Las reuniones se sincronizarán automáticamente.`
              : `Completando la conexión…`
          }
        />
      )),
      (e[5] = r),
      (e[6] = a),
      (e[7] = u))
    : (u = e[7]);
  let f;
  e[8] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((f = (
        <Sn
          to={`/calendario`}
          className={zo}
          children={`Volver al calendario`}
        />
      )),
      (e[8] = f))
    : (f = e[8]);
  let p;
  return (
    e[9] !== l || e[10] !== u
      ? ((p = (
          <EstructuraPrincipal
            title={`Conectar calendario`}
            children={
              <div
                className={`flex flex-col items-start gap-4`}
                children={[l, u, f]}
              />
            }
          />
        )),
        (e[9] = l),
        (e[10] = u),
        (e[11] = p))
      : (p = e[11]),
    p
  );
}
